import { render } from "./VideoViewerMobile.vue?vue&type=template&id=3597d978&scoped=true&ts=true"
import script from "./VideoViewerMobile.vue?vue&type=script&lang=ts"
export * from "./VideoViewerMobile.vue?vue&type=script&lang=ts"

import "./VideoViewerMobile.vue?vue&type=style&index=0&id=3597d978&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3597d978"]])

export default __exports__